export default __webpack_public_path__ + "static/wsl-grafana-start-160aff6f207edc14d9d9d60acb78d8da.webp";